<template>
  <subTopicTemplate>
    <template slot-scope="{ topic, subTopic }">
      <trueOrFalseGame :topic="topic" :subTopic="subTopic"  />
    </template>
  </subTopicTemplate>
</template>

<script type="text/javascript">
import subTopicTemplate from '@/components/template/subTopic'
import trueOrFalseGame from '@/components/game/trueOrFalseGame'

export default {
  components: {
    subTopicTemplate,
    trueOrFalseGame
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/library/units/topics/subtopics/trueOrFalseGame.vue